import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { KeyValue } from '../models/common';
import { Result } from '../models/common/resultResponse';
import { IWarehouseApi } from './base';
import { WarehouseFilterRequest } from '../models/request';

const baseRoute: string = 'Warehouse';

export class WarehouseApi extends IWarehouseApi {
  getDomain(
    request: WarehouseFilterRequest
  ): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/domain`, { params: request });
  }
}

